import { useModal } from 'Hooks'
import { useState } from 'react'

const ModalConnectGoogleCalendar = ({ onClose, calendars, onSubmit }) => {
  const { Modal, hide } = useModal({ identifier: 'modalConnectGoogleCalendar', visible: true, setVisible: onClose })

  const [checkedIds, setCheckedIds] = useState(
    calendars.filter((calendar) => calendar.is_synced).map((calendar) => calendar.google_calendar_id)
  )

  const handleToggle = (googleCalendarId) => {
    setCheckedIds((current) =>
      current.includes(googleCalendarId)
        ? current.filter((id) => id !== googleCalendarId)
        : [...current, googleCalendarId]
    )
  }

  const handleSubmit = async () => {
    await onSubmit(checkedIds)
    hide()
  }

  return (
    <Modal center>
      <div className="modal-content p-5 connectModal" style={{ maxWidth: 450 }}>
        <div className="modal-header">
          <div className="row text-center gy-2">
            <div className="col-12">
              <h3 className="modal-title fs-5" id="modalConnectGoogleCalendarLabel">Choose your calendars</h3>
            </div>
            <div className="col-12">
              <p className="m-0">Select the calendars you want Pulse to show alongside your tracked time.</p>
            </div>
          </div>
          <button type="button" className="btn-close modalConnect_close" onClick={() => hide()} />
        </div>

        <div className="modal-body">
          <div className="d-grid gap-2">
            {calendars.map((calendar) => (
              <div className="form-check" key={calendar.id}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id={`calendar-${calendar.id}`}
                  checked={checkedIds.includes(calendar.google_calendar_id)}
                  onChange={() => handleToggle(calendar.google_calendar_id)}
                />
                <label className="form-check-label" htmlFor={`calendar-${calendar.id}`}>
                  {calendar.color && (
                    <span
                      className="d-inline-block me-2"
                      style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: calendar.color }}
                    />
                  )}
                  {calendar.summary}
                </label>
              </div>
            ))}
          </div>

          <div className="row justify-content-between pt-4">
            <div className="col-auto">
              <button type="button" onClick={() => hide()} className="btn btn-secondary">Cancel</button>
            </div>
            <div className="col-auto">
              <button type="button" onClick={handleSubmit} className="btn btn-primary">Save calendars</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalConnectGoogleCalendar
